import type { FC } from 'react';
import React from 'react';
import type { GestureResponderEvent, StyleProp, ViewStyle } from 'react-native';
import { TouchableOpacity } from 'react-native';

type ITouchableProps = {
  containerStyle?: StyleProp<ViewStyle>;
  style?: StyleProp<ViewStyle>;
  disabled?: boolean;
  onPress?: (event: GestureResponderEvent) => void;
};

// @ts-expect-error
export const Touchable: FC<ITouchableProps> = ({ children, ...rest }) => (
  <TouchableOpacity {...rest}>{children}</TouchableOpacity>
);
